import { Optional } from 'utility-types';

import { FACETS_ORDER } from '@app/components';

export interface MappedFacetValue {
  value: string;
  count: number;
  id: string;
  label: string;
}

export interface UnmappedFacetValue {
  id: string;
  totalRecords: number;
}

type FacetsItemDto = {
  values: UnmappedFacetValue[];
  totalRecords: number;
};

export interface FacetsDto {
  facets: Optional<
    Record<
      | 'sourceTypes'
      | 'languages'
      | 'items.effectiveLocationId'
      | 'instanceSubjects'
      | 'instancePublishers'
      | 'patronItemStatus',
      FacetsItemDto
    >
  >;
}

export type FacetInstanceDto = Record<
  (typeof FACETS_ORDER)[0],
  {
    label: string;
    values:
      | null
      | {
          id: string;
          value: string;
          count: number;
        }[];
    isError?: boolean;
  }
>;

export const FACET_SHOW_MORE_LIMIT = 6;

export const FACET_LIMIT = 500;
